import Main from './containers/Main';
import reducer from './services/reducer';
import { MainState, mainSelectors } from './services/selectors';
import epics from './services/epics';

export { reducer, MainState, epics, mainSelectors };

export default Main;



// WEBPACK FOOTER //
// ./src/Main/index.ts